<template>
    <div>
        <vue-topprogress ref="topProgress"></vue-topprogress>
        <div class="min-h-screen flex flex-col bb-view-background">
            <PermissionCheck permission="drg.app.header.view">
                <Header />
            </PermissionCheck>
            <div
                class="mx-auto w-full bb-max-width px-4 flex flex-col pt-6 pb-6 flex-1"
            >
                <router-view :key="$route.path" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import Header from "@/components/common/Header";
import { vueTopprogress } from "vue-top-progress";
import PermissionCheck from "@/components/common/PermissionCheck";

export default {
    name: "App",
    data() {
        return {
            something: Math.random()
        };
    },
    computed: mapGetters({ loader: "loader/loader" }),
    watch: {
        loader(value) {
            if (value) this.$refs.topProgress.start();
            else this.$refs.topProgress.done();
        }
    },
    components: {
        PermissionCheck,
        Header,
        vueTopprogress
    }
};
</script>

<style>
@import "~@braid/vue-formulate/dist/snow.min.css";
/* @import "~@fortawesome/fontawesome-free/css/all.min.css"; */
@import "~material-icons/iconfont/material-icons.css";
/* Import one of the available themes */
/* import 'vue-toast-notification/dist/theme-default.css'; */
@import "~vue-toast-notification/dist/theme-sugar.css";

@tailwind base;
@tailwind components;
@tailwind utilities;

html,
body {
    margin: 0;
    padding: 0;
    overflow-x: hidden;
}

#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}
.bb-max-width {
    max-width: 832px;
}
</style>
